import React, { useState } from 'react';
import API_BASE from '../config';

function AdminLogin({ onLogin }) {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async () => {
    setError('');
    
    if (!code.trim()) {
      setError('Inserire il codice di accesso.');
      return;
    }
    
    try {
      const response = await fetch(`${API_BASE}/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code })
      });
      
      if (response.ok) {
        const data = await response.json();
        onLogin({ code, ...data });
      } else {
        setError('Codice di accesso non valido.');
      }
    } catch (err) {
      setError('Impossibile connettersi al server.');
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleLogin();
  };

  return (
    <div className="admin-login">
      <h2>Accesso Amministrativo</h2>
      <p style={{ color: '#666', marginBottom: '20px' }}>
        Inserire il codice di accesso per visualizzare le registrazioni e gestire il sistema.
      </p>
      <div className="form-group">
        <label>Codice di Accesso</label>
        <input
          type="text"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Inserire il codice di accesso"
        />
      </div>
      {error && <div className="error">{error}</div>}
      <button className="btn-primary" onClick={handleLogin}>
        Accedi
      </button>
    </div>
  );
}

export default AdminLogin;
